class HrOnboardingResponse {
  constructor(response = {}) {
    this.newEmployees = response.data.employees || 0;
    this.newTiers = response.data.tiers || 0;
  }
}

export default HrOnboardingResponse;
